/* eslint-disable react/jsx-filename-extension */
import hordBanner from '../images/hpool-banner.png';
import vPoolBanner from '../images/v-dao-header.png';
import {
  claimVpoolTokens,
  vpoolCheckChampionDepositRefund,
  vpoolGetUserSubscriptionForPool,
  vpoolRefundChampionOnFail,
  vpoolWithdrawDepositReq,
} from '../services/vpoolService';
import { hpoolInfoSrc } from './hpool';

export const CUSTOM_TOEKN_ADDRESS_FOR_CLOSE_ORDER_KEY = '285cg03294173bba907d925d8rc99215139299kl';

export const HAS_ACCESS_TO_PROD_KEY = '4df3c3f68fcc83b27';
export const ACCESS_TO_PROD_KEY_PASS =
  '88cb8590db3e048666f1b14df1f293999b077c27305369774a01f22da089883d3c1f24d06c5cb2acba60fbb72cf05ced03f40a0d0d731710309c370a0c29793d';

export const participateAbi = [
  {
    internalType: 'bytes',
    name: 'signature',
    type: 'bytes',
  },
  {
    internalType: 'uint256',
    name: 'poolId',
    type: 'uint256',
  },
];
export const _participateAbi = {
  inputs: [
    {
      internalType: 'bytes',
      name: 'signature',
      type: 'bytes',
    },
    {
      internalType: 'uint256',
      name: 'poolId',
      type: 'uint256',
    },
  ],
  name: 'subscribeForVPool',
  outputs: [],
  stateMutability: 'payable',
  type: 'function',
};

export const subscribeForVPoolAbi = [
  {
    internalType: 'bytes',
    name: 'signature',
    type: 'bytes',
  },
  {
    internalType: 'uint256',
    name: 'poolId',
    type: 'uint256',
  },
  {
    internalType: 'uint256',
    name: 'amountUsd',
    type: 'uint256',
  },
];

const vpoolInfoSrc = {
  contractName: 'HordVpoolManager',
  configContract: 'HordVpoolConfiguration',
  poolInfoMethod: 'vPool',
  headerBanner: vPoolBanner,
  userTabs: [{ id: 'proposed_participations' }, { id: 'tx_history' }],
  newOrderTabs: [
    { id: 'openOrder', title: 'Open Order' },
    { id: 'closeOrder', title: 'Close Order' },
    { id: 'closePortion', title: 'Close Portion' },
  ],
  openOrderTabs: [
    { id: '', title: 'All' },
    { id: 'closeOrder', title: 'Close Order' },
    { id: 'openOrder', title: 'Open Order' },
    { id: 'closePortion', title: 'Close Portion' },
  ],
  claimPoolTokensMethod: claimVpoolTokens,
  checkChampionDepositRefund: vpoolCheckChampionDepositRefund,
  refundChampion: vpoolWithdrawDepositReq,
  refundUser: vpoolWithdrawDepositReq,
  getUserSubscriptionForPool: vpoolGetUserSubscriptionForPool,
  subscribtionMethodInput: (hpool) => [
    'HordVpoolManager', // added this as a change maker at useMethodInput so contractName is linked with signature
    'subscribeForVPool',
    ...[hpool.userSignature, hpool.web3_hpool_id],
  ],
  subscribtionAbi: [
    {
      internalType: 'bytes',
      name: 'signature',
      type: 'bytes',
    },
    {
      internalType: 'uint256',
      name: 'poolId',
      type: 'uint256',
    },
  ],
  isPoolCreationPayable: false,
};

const multiTypePoolSrc = {
  vpool: vpoolInfoSrc,
  hpool: hpoolInfoSrc,
};

export const manualOrdersTypes = {
  MANUAL_OPEN_ORDER: 'MANUAL_OPEN_ORDER',
  MANUAL_CLOSE_ORDER: 'MANUAL_CLOSE_ORDER',
  MANUAL_CLOSE_PORTION: 'MANUAL_CLOSE_PORTION',
};

// map signature object payload to a valid BE request body
export const manualOrdersMapperSchema = {
  vpoolId: 'vpool_id',
  chainId: 'chain_id',
  amountUSDToWithdraw: 'amount_to_withdraw',
  amountOfTokensToReturn: 'total_tokens_to_receive',
  totalTokensToBeReceived: 'total_tokens_to_receive',
  amountOfTokensToReceiveNow: 'amount_to_deposit',
  amountOfTokensToReceive: 'amount_to_deposit',
  stableCoinSymbol: 'token_to_withdraw_symbol',
  tokenToReceiveSymbol: 'token_to_receive_symbol',
  finalTokenPrice: 'champion_price',
  tokenAddress: 'token_address',
  numberOfPortions: 'number_of_portions',
  unLockingTime: 'unlocking_time',
  portionId: 'portion_id',
};

export const vpoolTypesMapper = {
  OpenOrder: [
    { name: 'poolId', type: 'uint256' },
    { name: 'tokenId', type: 'uint256' },
    { name: 'amountUSDToWithdraw', type: 'uint256' },
    { name: 'amountOfTokensToReturn', type: 'uint256' },
  ],
  CloseOrder: [
    { name: 'tokenId', type: 'uint256' },
    { name: 'totalTokensToBeReceived', type: 'uint256' },
    { name: 'finalTokenPrice', type: 'uint256' },
    { name: 'amountOfTokensToReceiveNow', type: 'uint256' },
    { name: 'tokenAddress', type: 'address' },
  ],
  ClosePortion: [
    { name: 'tokenId', type: 'uint256' },
    { name: 'portionId', type: 'uint256' },
    { name: 'amountOfTokensToReceive', type: 'uint256' },
  ],
};

export const typeMapperKeys = (key) => vpoolTypesMapper[key].map((elem) => elem.name);

export const multiTypePoolManager = (isVpool) => {
  const poolType = isVpool ? 'vpool' : 'hpool';
  return multiTypePoolSrc?.[poolType];
};

export const poolCraetionAbi = [
  {
    internalType: 'uint256',
    name: 'bePoolId',
    type: 'uint256',
  },
];
